import './style.scss';

export function image_and_text_block() {
    const block = document.querySelector('.image_and_text_block');
    if (!block) return;
}

